import React from "react";

function Epson() {
    return (
        <h1>This si epson page</h1>
    );
}

export default Epson